import styled from "styled-components";
import * as UIConstants from "../../../UIConstants";
interface ActiveInactiveProp {
  active: boolean
}

export const Wrapper = styled.div`
  margin: 0;
  padding: 0;
`;
export const SectionWrapper = styled.div`
  font-family: Arial, sans-serif;
  background-color: #f0f0f0;
  margin: 0;
  padding: 0;
`;
export const Header = styled.header`
  background-color: #003459;
  color: #fff;
  padding: 10px;
  text-align: center;
`;

export const Container = styled.div`
  max-width: 800px;
  margin: 20px auto;
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  
`;

export const UserInfo = styled.div`
 display:flex;
 gap:80px;
 
 flex-wrap:wrap;
  // margin-top: 20px;
  ${UIConstants.mobileView}{
    gap:20px;
  justify-content:center;

  }
`;

export const ActionWrapper = styled.div`
margin: 0;
  padding: 0;
  border: 1px solid gray;
  border-radius:10px;
  padding:10px;
`

export const Action = styled.div`
margin-top:50px;
Button{
  width:110px;
}

`;
export const ActionStaus = styled.div`
margin-top:20px;
display:flex;
justify-content:space-between;
align-item:center;

`;
export const Active = styled.span<ActiveInactiveProp>`
margin-left:10px;
padding: 5px 8px 5px 8px;
width: 100%;
height: 100%;
background:${(props) => props.active ? 'rgba(33, 150, 83, 0.1)' : 'rgba(235, 87, 87, 0.1)'} ;
border: ${(props) => props.active ? '1px solid #219653' : '1px solid red'} ;
border-radius: 4px;
font-size: 12px;
color: ${(props) => props.active ? '#219653' : '#EB5757'};
`;
export const ActionWallet = styled.div`
margin-top:20px;
display:flex;
justify-content:space-between;
align-item:center;

`;
export const ActionDetail = styled.div`
margin-top:5px;

`;

export const ProfileImageWrapper = styled.div`
width:300px;
height:350px;
border-radius:10px;

`;

export const ProfileImage = styled.img`
width:300px;
height:350px;
border-radius:10px;

`;
export const ModalWrapper = styled.div`
// width:100%;
padding:20px 50px 10px 50px;
`
export const ModalImg = styled.div`

`
export const ModalMessege = styled.h2`

`
export const ModalData = styled.h2`
width:100%;
padding:0 50px 0 50px;
`
export const UserBalance = styled.h4`

`
export const ModalAction = styled.h2`
 display:flex;
 justify-content:flex-end;
 gap:5px;
`
export const ModalFrom = styled.div`
    margin:10px;
`

export const ModalBtn = styled.div`
justify-content:flex-end;
display:flex;
gap:10px;
`
export const InputSection = styled.div`
display:flex;
gap:10px;
`